import azureCertification from '../img/azureCertification.png';
import javaCertification from '../img/javaCertification.png';

const dataCertifications = [
  {
    logoCertification: azureCertification,
    nameCertification: 'Azure Fundamentals (Az-900)',
    companyCertification: 'Microsoft',
    dateCertificationSpanish: 'Agosto 2022',
    dateCertificationEnglish: 'August 2022',
    credentialCertification: 'wEAJH-48Eq',
    verificationLink: [
      'https://www.certiport.com/portal/pages/credentialverification.aspx',
      'https://www.credly.com/badges/87c4975c-1715-4e29-a087-85c9c6b39617/linked_in_profile',
    ],
  },
  {
    logoCertification: javaCertification,
    nameCertification: 'Introduction to Programming using Java',
    companyCertification: 'Microsoft',
    dateCertificationSpanish: 'Junio 2022',
    dateCertificationEnglish: 'June 2022',
    credentialCertification: 'nBPc-DwQv',
    verificationLink: [
      'https://www.certiport.com/portal/pages/credentialverification.aspx',
      'https://www.credly.com/badges/08359e90-09e1-4d53-a43f-e4f3c3171981/linked_in_profile',
    ],
  },
];

export default dataCertifications;
